import { Component, OnInit } from '@angular/core';
import { IdleMonitorService } from '@scullyio/ng-lib';

@Component({
  selector: 'app-media-page',
  templateUrl: './media-page.component.html',
  styleUrls: ['./media-page.component.scss']
})
export class MediaPageComponent implements OnInit {

  constructor(
    private ims: IdleMonitorService,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.ims.fireManualMyAppReadyEvent()
    })
  }

  public isLogosVisible = false
  public isForMediaVisible = false
  public isPublicationsVisible = false

  public logos = [
    // {
    //   title: 'RGB colors',
    //   svg: 'https://firebasestorage.googleapis.com/v0/b/energo-toplinarstvo.appspot.com/o/f',
    //   pdf: 'https://firebasestorage.googleapis.com/v0/b/energo-toplinarstvo.appspot.com/o/f',
    //   png: 'https://firebasestorage.googleapis.com/v0/b/energo-toplinarstvo.appspot.com/o/f',
    // },

  ]

  public forMedia = [
    {
      title: 'Prezentacija projekta i najava početka radova',
      external: 'https://firebasestorage.googleapis.com/v0/b/energo-toplinarstvo.appspot.com/o/flamelink%2Fmedia%2FPrezentacija%20projekta%20i%20najava%20poc%CC%8Cetka%20radova_materijal%20za%20medije.pdf?alt=media&token=023e5a6b-4e33-4cbc-a865-b11169782472',
    }
  ]

  public publications = [
    {
      title: 'Letak projekta',
      external: 'https://firebasestorage.googleapis.com/v0/b/energo-toplinarstvo.appspot.com/o/flamelink%2Fmedia%2F15122021%20Letak.pdf?alt=media&token=03dab665-3b93-4eff-97c5-ef5ebf417159',
    }
  ]

}
